import Image from 'next/image';
import { useMemo } from 'react';

import { getAddressScannerUrl, maskAddressValue } from '@/utils/format';

import { EventTriggerType, Trigger } from '../../domain';
import { TriggerExternalLinkDetail } from './components/TriggerExternalLinkDetail';
import { TriggerType } from './components/TriggerType';

interface Props {
  trigger: Trigger;
  triggerType: EventTriggerType;
}

export const FelixCdpCollateralTriggerDetails = ({ trigger, triggerType }: Props) => {
  const tokenAddress = useMemo(() => {
    return trigger.context?.tokenAddress || '';
  }, [trigger.context]);

  const scannerUrl = useMemo(() => {
    if (!tokenAddress) return '';
    return getAddressScannerUrl('chainId', 999, tokenAddress) ?? '';
  }, [tokenAddress]);

  return (
    <div className="tw:flex tw:flex-row tw:gap-6">
      <TriggerType eventType={triggerType} />

      <TriggerExternalLinkDetail
        label="Collateral Address"
        value={
          <div className="tw:flex tw:flex-row tw:gap-1 tw:items-center">
            <Image src="/assets/svg/hyperevm.svg" width={12} height={12} alt="HyperEVM" />
            <span>{maskAddressValue(tokenAddress) ?? ''}</span>
          </div>
        }
        href={scannerUrl}
      />
    </div>
  );
};
